/**
 * ZoneIndicator Component
 * Shows which navigation zone is currently active
 */

import { motion } from 'framer-motion';
import type { NavigationZone } from '@/types';
import clsx from 'clsx';

interface ZoneIndicatorProps {
  activeZone: NavigationZone;
}

const ZONES: { key: NavigationZone; label: string }[] = [
  { key: 'sidebar', label: 'Sidebar' },
  { key: 'main', label: 'Concierge' },
  { key: 'tv', label: 'TV' },
];

export function ZoneIndicator({ activeZone }: ZoneIndicatorProps) {
  return (
    <div className="zone-indicator">
      {ZONES.map(({ key, label }) => (
        <motion.div
          key={key}
          className={clsx('zone-pill', { active: activeZone === key })}
          animate={{
            scale: activeZone === key ? 1.05 : 1,
          }}
          transition={{ duration: 0.2 }}
        >
          {label}
        </motion.div>
      ))}
      <div className="ml-2 text-xs text-zaxia-gray opacity-60">
        Tab to switch
      </div>
    </div>
  );
}
